import { useTranslation } from "react-i18next";
import { MdContactless, MdMailOutline } from "react-icons/md";

export default function GiftcardDecor() {
  const { t } = useTranslation();
  return (
    <div
      className="font-poppins w-110 bg-background-active relative flex min-w-80 flex-col gap-4 overflow-hidden rounded-2xl p-5 py-12 text-white shadow-2xl shadow-blue-500/30"
      aria-hidden={true}
    >
      <div className="font-poppins absolute -end-16 -top-16 size-56 rounded-full bg-white/10" />
      <div className="relative flex w-full items-center justify-between">
        <div className="text-xs font-semibold uppercase tracking-widest">{t("Landing.decor.giftcard.label")}</div>
        <MdContactless className="size-5" />
      </div>
      <div className="relative flex items-center gap-4">
        <div className="bg-background-secondary h-7 w-9 rounded-md shadow-sm" />
        <div className="text-4xl font-bold">{t("Landing.decor.currency", { value: 500 })}</div>
      </div>
      <div className="relative flex items-center gap-2 text-xs">
        <MdMailOutline className="size-4 shrink-0" />
        <span>{t("Landing.decor.giftcard.description")}</span>
      </div>
      <div className="relative mt-2 flex items-center justify-between">
        <div className="text-font-inverted text-sm tracking-widest">•••• 2580</div>
        <div className="flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-sm font-semibold text-slate-900 shadow-sm">
          <span className="bg-background-secondary size-3 rounded-full" />
          {t("Landing.decor.points", { value: "25,000" })}
        </div>
      </div>
    </div>
  );
}
